var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.814,
    height: 5.831,
    viewBox: "0 0 6.814 5.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-button-down-2",
    d: "M7.014,2.262a.581.581,0,0,0-.506-.3H.856a.581.581,0,0,0-.5.882l2.826,4.67a.581.581,0,0,0,.994,0l2.826-4.67A.581.581,0,0,0,7.014,2.262Z",
    transform: "translate(-0.275 -1.966)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.91d93cd3e7a4fdd289b92f59c0148c06.svg";
export { ForwardRef as ReactComponent };